import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts, richTextEditor } from 'app/components/global';
import controller from './edit-emergency-procedure-dialog.controller';
import template from './edit-emergency-procedure-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, procedure }) {
    return {
      controller,
      controllerAs: 'editEmergencyProcedureDialogVM',
      locals: {
        assessmentId,
        procedure
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editEmergencyProcedureDialog', [
  alerts,
  richTextEditor,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editEmergencyProcedureDialog', dialogService)
  .name;
